import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';

const GoogleSignIn = () => {
  const { login } = useAuth();

  const handleSuccess = async (credentialResponse: CredentialResponse) => {
    try {
      if (credentialResponse.credential) {
        await login(credentialResponse.credential);
      }
    } catch (error) {
      console.error('[GoogleSignIn] Login failed:', error);
    }
  };

  const handleError = () => {
    console.error('[GoogleSignIn] Sign-in failed — possible causes: popup blocked, user cancelled, OAuth misconfiguration, or unauthorized origin');
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={handleError}
      theme="filled_black"
      size="large"
      type="standard"
      shape="pill"
    />
  );
};

export default GoogleSignIn;